import { utils } from 'formiojs/utils';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subscription, forkJoin, Subject, Observable, debounceTime, distinctUntilChanged } from 'rxjs';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import _cloneDeep from 'lodash/cloneDeep';
import { SelectionModel } from '@angular/cdk/collections';
import { Utils } from 'formiojs';
import { AddEditDialog } from './add-edit-dialog/add-edit-dialog.component';
import { FormioLoader, FormioCustomComponent, ResourceNameService } from 'dp-formio';
import * as DeleteConfirmationDialog from 'dp-formio';

@Component({
    selector: 'app-table-tree-wrapper',
    templateUrl: './table-tree-wrapper.component.html',
    // styleUrls: ['./table-tree-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class TableTreeWrapperComponent implements FormioCustomComponent<any>, OnChanges, OnDestroy {
    dir: "rtl" | "ltr";
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;
    private sub: Subscription;
    name: string;
    readonly dataSource: BehaviorSubject<any[]>;
    readonly filterDataSource: BehaviorSubject<any[]>;
    readonly treeSource: MatTreeNestedDataSource<any>;
    readonly filteredTreeSource: MatTreeNestedDataSource<any>;
    filterUpdate = new Subject<string>();
    filterKeyword = '';
    /** tree control */
    readonly treeControl = new NestedTreeControl<any>(node => node.childrens);
    readonly hasChild = (_: number, node: any) => !!node.childrens && node.childrens.length > 0;
    readonly trackBy = (_: number, node: any) => node.id;

    branches = [];

    windowProperties = {
        fullscreen: false,
        open: false
    };
    activeNode = null;
    activeParentNode = null;
    activeNodeData = null;
    activeNodeState: 'add' | 'edit';

    showMainBranch: any;

    modifyInDialog: boolean;

    constructor(private translateService?: TranslateService,
        private resourceNameService?: ResourceNameService,
        private formioLoader?: FormioLoader,
        private dialog?: MatDialog) {
        if (this.translateService) {
            this.initFilterListener();
            this.treeSource = new MatTreeNestedDataSource<any>();
            this.filteredTreeSource = new MatTreeNestedDataSource<any>();

            this.dataSource = new BehaviorSubject<any[]>([]);
            this.filterDataSource = new BehaviorSubject<any[]>([]);

            this.dataSource.subscribe(items => {
                this.treeSource.data = null;
                this.treeSource.data = items;
            });

            this.filterDataSource.subscribe(items => {
                this.filteredTreeSource.data = null;
                this.filteredTreeSource.data = items;
            });

            this.dataSource.next([]);
            this.filterDataSource.next([]);
            // this.notifyValue();
            this.changeDirection(this.translateService.currentLang);
            this.sub = this.translateService.onLangChange.subscribe(data => {
                this.changeDirection(data.lang);
            });
            this.sub = this.checklistSelection.changed.subscribe(data => {
                console.log(data.source.selected);
            });
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        this.formioLoader.loading = false;
        if (this.customOptions) {
            this.name = Object.keys(this.customOptions)[0];
            if (this.customOptions.modifyInDialog) this.modifyInDialog = this.customOptions.modifyInDialog;
            this.checkMainBranch();
            if (this.value) this.fillData();
        }
    }

    private changeDirection(lang) {
        this.dir = null;
        setTimeout(() => {
            this.dir = lang == 'ar' ? 'rtl' : 'ltr';
        });
    }

    checkIsMain = (item, prop, node?) => {
        if (this.showMainBranch && this.showMainBranch?.fieldName) {
            if (prop && prop.rowSubmission) {
                item.isMain = prop.rowSubmission.data[this.showMainBranch.fieldName] == true;

            } else if (node && node.rowSubmission) {
                item.isMain = node.rowSubmission.data[this.showMainBranch.fieldName] == true;
            }

        }
    }
    checkResources = (item, prop, node?) => {
        if (prop && prop.resource) {
            item.resource = prop.resource;
            item.extra = prop.extra;

        } else if (node && node.resource) {
            item.resource = node.resource;
            item.extra = node.extra;
        }
    }
    dialogConfig = (prop, node?) => {
        const item: any = {
            dir: this.dir,
            isAdd: prop.isAdd,
            name: prop.name ?? node.translatedName,
            fields: prop.fields ?? _cloneDeep(node.fields),
            branches: this.branches,
            rowSubmission: prop.rowSubmission ?? (node?.rowSubmission ?? null),
            parentRowSubmission: prop.parentRowSubmission ?? (node?.parentRowSubmission ?? null),
            resource: prop.resource ?? node.resource,
            apiKey: prop.apiKey ?? node.apiKey,
            parentApiKey: prop.parentApiKey ?? node.parentApiKey,
            extra: prop.extra ?? node.extra,
            disableFields: prop.disableFields ?? (node?.disableFields ?? null),
            icon: prop.icon ?? node.icon,
            color: prop.color ?? node.color,
            isView: prop.viewMode ?? false,
            data: this.data,
            value: this.branches
        }
        this.checkIsMain(item, prop, node);
        this.checkResources(item, prop, node);
        return item;
    };
    itemSetup = (prop, node?) => {
        const item: any = {
            id: prop.id ?? node.id,
            name: prop.name ?? node.prop,
            translatedName: prop.translatedName ?? node.translatedName,
            fields: prop.fields ?? node.fields,
            branches: this.branches,
            rowSubmission: prop.rowSubmission ?? node.rowSubmission,
            parentRowSubmission: prop.parentRowSubmission ?? node.parentRowSubmission,
            resource: prop.resource ?? node.resource,
            apiKey: prop.apiKey ?? node.apiKey,
            parentApiKey: prop.parentApiKey ?? node.parentApiKey,
            extra: prop.extra ?? node.extra,
            disableFields: prop.disableFields ?? node.disableFields,
            icon: prop.icon ?? node.icon,
            color: prop.color ?? node.color,
            actions: prop.actions ?? node.actions,
            childrens: prop.children ?? node.childrens
        };
        this.checkIsMain(item, prop, node);
        this.checkResources(item, prop, node);
        return item;
    };

    createDialog(isAdd: boolean, level: any, parentNode = null) {
        this.clearActive();
        this.activeNodeState = 'add';
        this.activeNode = level;
        this.activeParentNode = parentNode;
        this.activeNodeData = this.dialogConfig({
            isAdd: isAdd,
            name: Object.keys(level)[0],
            fields: _cloneDeep(level[Object.keys(level)[0]].fields),
            rowSubmission: level[Object.keys(level)[0]].rowSubmission,
            parentRowSubmission: parentNode?.rowSubmission ?? null,
            resource: level[Object.keys(level)[0]].resource,
            apiKey: level[Object.keys(level)[0]].apiKey,
            parentApiKey: level[Object.keys(level)[0]].parentApiKey,
            extra: level[Object.keys(level)[0]].extra,
            disableFields: level[Object.keys(level)[0]].disableFields,
            icon: level[Object.keys(level)[0]].icon,
            color: level[Object.keys(level)[0]].color,
            data: this.data
        });
        this.checkOpenInDialog();
    }

    editDialog(node: any) {
        this.clearActive();
        this.activeNodeState = 'edit';
        this.activeNode = node;
        this.activeParentNode = null;
        this.activeNodeData = this.dialogConfig({ isAdd: false }, node);
        this.checkOpenInDialog();
    }

    viewDialog(node: any) {
        this.clearActive();
        this.activeNode = node;
        this.activeNodeData = this.dialogConfig({ viewMode: true }, node);
        this.checkOpenInDialog();
    }

    private checkOpenInDialog() {
        if (this.modifyInDialog) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.id = Utils.guid();
            dialogConfig.panelClass = "custom-modal-component";
            dialogConfig.direction = this.dir;
            dialogConfig.data = this.activeNodeData;
            this.dialog.closeAll();
            const modalDialog = this.dialog.open(AddEditDialog, dialogConfig);
            modalDialog.afterClosed().subscribe(data => {
                this.closeActive(data);
            });
        }
    }

    closeActive(result: any) {
        if (result) {
            this.formioLoader.loading = true;
            if (this.activeNodeState == 'add') {
                this.fillSource(result, this.activeNode, this.activeParentNode)
            } else if (this.activeNodeState == 'edit') {
                const comfirmed = result?.rowSubmission?.data?.accredited ? `<span class="confirmed"></span>` : '';
                const colorStyle = result.color ? `color: ${result?.color} !important;` : '';
                const icon = result.icon ? `<i class="${result.icon}" style="${colorStyle}"></i>` : '';
                const item = this.itemSetup({
                    name: `${icon || ''} <span class="confirmed-container">${comfirmed}</span> <strong style="${colorStyle}">${this.translateService.instant(`forms.common.${this.activeNode.translatedName}`)} :</strong>` + result.fields.filter(q => q.viewInTree && q.value).map(q => q.value).join(' • '),
                    fields: result.fields,
                    rowSubmission: result.rowSubmission,
                    parentRowSubmission: result.parentRowSubmission,
                    resource: result.resource,
                    apiKey: result.apiKey,
                    parentApiKey: result.parentApiKey,
                    extra: result.extra,
                    disableFields: result.disableFields,
                }, this.activeNode);
                this.findInDataSourceAndUpdate(this.dataSource.value, item);
                this.dataSource.next([...this.dataSource.value]);
                this.notifyValue();
            }
            this.formioLoader.loading = false;
        }
        this.clearActive();
    }
    clearActive() {
        this.activeNode = null;
        this.activeParentNode = null;
        this.activeNodeData = null;
        this.activeNodeState = null;
    }


    fillSource(result: any, level: any, parentNode = null, notify: boolean = true) {
        const comfirmed = level[Object.keys(level)[0]].confirmedFieldName && result?.rowSubmission?.data[level[Object.keys(level)[0]].confirmedFieldName] ?
            `<span class="confirmed"></span>` : '';
        const colorStyle = result.color ? `color: ${result?.color} !important;` : '';
        const icon = result?.icon ? `<i class="${result?.icon}" style="${colorStyle}"></i>` : '';
        const newItem = this.itemSetup({
            id: Utils.guid(),
            name: `${icon || ''} <span class="confirmed-container">${comfirmed}</span> <strong style="${colorStyle}">${this.translateService.instant(`forms.common.${Object.keys(level)[0]}`)} : </strong>` + result.fields.filter(q => q.viewInTree && q.value).map(q => q.value).join(' • '),
            translatedName: Object.keys(level)[0],
            actions: level[Object.keys(level)[0]].actions,
            children: []
        }, result);
        if (parentNode) {
            this.findInDataSourceAndFill(this.dataSource.value, parentNode, newItem);
            this.dataSource.next([...this.dataSource.value]);
            if (notify) this.notifyValue();
            return newItem;
        } else {
            this.dataSource.next([
                ...this.dataSource.value,
                {
                    ...newItem
                }
            ]);
            if (notify) this.notifyValue();
            return newItem;
        }
    }

    createNode(parentNode, bindWith) {
        const node = this.findNode(this.customOptions, bindWith);
        this.createDialog(true, node, parentNode);
    }

    findNode(startedPoint, bindWith) {
        for (let item in startedPoint) {
            if (item == bindWith) return startedPoint;
            else {
                const branchOfNods = startedPoint[item].childrens.find(q => this.findNode(q, bindWith));
                if (branchOfNods) return this.findNode(branchOfNods, bindWith);
            }
        }
    }
    findNodeByKey(startedPoint, key) {
        for (let item in startedPoint) {
            if (Object.values(startedPoint[item]).includes(key)) return startedPoint[item];
            else {
                const bindWith = startedPoint[item].actions?.find(q => !!q.bindWith)?.bindWith ?? null;
                if (bindWith) {
                    const branchOfNods = startedPoint[item].childrens.find(q => this.findNode(q, bindWith));
                    if (branchOfNods) return this.findNodeByKey(branchOfNods, key);
                }
            }
        }
    }

    findInDataSourceAndFill(startedPoint, parentNode, newItem) {
        startedPoint.forEach(q => {
            if (q.id == parentNode.id) q.childrens.push(newItem);
            else this.findInDataSourceAndFill(q.childrens, parentNode, newItem);
        });
    }

    findInDataSourceAndUpdate(startedPoint, item) {
        for (let index = 0; index < startedPoint.length; index++) {
            if (startedPoint[index].id == item.id) startedPoint[index] = { ...item };
            else this.findInDataSourceAndUpdate(startedPoint[index].childrens, item);
        }
    }

    removeNode(node) {
        if (node.childrens && node.childrens.length) {
            DeleteConfirmationDialog.build(this.formioComponent, null, null,
                'This item cannot be deleted Please delete the items associated with it first');
            return;
        }
        //check if has related
        if (this.customOptions.relatedEntityWhenDelete) {
            let hasRelated = false;
            this.customOptions.relatedEntityWhenDelete.forEach(item => {
                const result = Utils.evaluate(item.value, { removedId: node.rowSubmission._id, value: this.data[item.key] });
                if (result) hasRelated = true;
            });

            if (hasRelated) {
                DeleteConfirmationDialog.build(this.formioComponent, null, null,
                    'This item cannot be deleted Please delete the items associated with it first');
                return;
            }
        }

        //delete item
        DeleteConfirmationDialog.build(this.formioComponent, () => {
            this.deleteFromResource(node);
        }, null, 'Are you sure to delete this item');
    }

    deleteFromResource(node) {
        this.formioLoader.loading = true;
        this.sub = this.resourceNameService.deleteResourceData(node.resource, node.rowSubmission._id)
            .subscribe(() => {
                const data = this.dataSource.value;
                this.dataSource.next(this.deepRemoveNode(_cloneDeep(data), node));
                this.checklistSelection.clear();
                this.clearActive()
                this.notifyValue();
                this.formioLoader.loading = false;
            }, error => {
                this.formioLoader.loading = false;
            });
    }

    deepRemoveNode(data: any[], node: any | any[]) {
        const result = [];
        data.forEach(item => {
            if (item.childrens && item.childrens.length)
                item.childrens = this.deepRemoveNode(item.childrens, node);
            if (node instanceof Array) {
                if (!node.find(q => q.id == item.id)) result.push(item);
            } else if (item.id != node.id) result.push(item);
        });
        return result;
    }

    getRemovedNode(data: any[], node: any | any[], removedNodes: any[] = []) {
        data.forEach(item => {
            if (item.childrens && item.childrens.length)
                this.getRemovedNode(item.childrens, node, removedNodes);

            if (item.id && item.id == node.id && item.fields && item.fields.length)
                removedNodes.push(item.fields[0].value);
        });

        return removedNodes;
    }

    hasAction(node, action) {
        return !!node.actions.find(q => q.name == action);
    }

    private initFilterListener() {
        this.sub = this.filterUpdate.pipe(
            debounceTime(350),
            distinctUntilChanged())
            .subscribe(keyword => {
                this.filterData(keyword);
            });
    }

    private filterData(keyword: string = '') {
        if (keyword.length) {
            const data = [];
            this.dataSource.value.forEach(node => {
                this.recursiveFilterNode(keyword, data, node, node);
            });
            this.filterDataSource.next(data);
        } else {
            this.filterDataSource.next([]);
            this.filterDataSource.next(_cloneDeep(this.dataSource.value));
        }
    }

    private recursiveFilterNode(keyword: string, array: any[], parentNode: any, currentNode: any) {
        if (currentNode.fields.some(f => f.value.includes(keyword))) {
            if (array.find(n => n.id == parentNode.id)) return;
            array.push(parentNode);
        } else {
            if (currentNode.childrens)
                currentNode.childrens.forEach(c => {
                    this.recursiveFilterNode(keyword, array, parentNode, c);
                });
        }
    }

    private notifyValue() {
        this.filterData(this.filterKeyword);
        const branches = [];
        for (const temp of this.dataSource.value) {
            let item = this.getFiledsValue(temp);
            this.getChildrensValue(item, temp);
            branches.push(item);
        }
        this.branches = branches;

        const branchesIds = [];
        for (const temp of this.dataSource.value) {
            let item = this.getFiledsValue(temp, true);
            this.getChildrensValue(item, temp, true);
            branchesIds.push(item);
        }
        this.value = { branchesData: branchesIds };
        this.valueChange.emit(this.value);

        setTimeout(() => {
            this.saveResultObjectsOn();
            this.afterChangeValue();
            this.checkMainBranch();
        });
    }

    private saveResultObjectsOn() {
        if (this.customOptions && this.customOptions.saveResultObjectsOn) {
            if (this.formioComponent.root.wizard) {
                const pages = this.formioComponent.root.getFastPages({ all: true, withoutFirstLoad: true });
                const components = Utils.searchComponents(pages, { key: this.customOptions.saveResultObjectsOn });
                components.forEach(c => {
                    c.setValue(this.branches ?? []);
                });
            } else {
                const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form', 'component.display': 'wizard' });
                nestedForms.forEach(formComponent => {
                    formComponent.subFormReady.then((subForm) => {
                        const pages = subForm.getFastPages({ all: true, withoutFirstLoad: true });
                        const components = Utils.searchComponents(pages, { key: this.customOptions.saveResultObjectsOn });
                        components.forEach(c => {
                            c.setValue(this.branches ?? []);
                        });
                    });
                });
            }
        }
    }

    checkMainBranch() {
        if (this.customOptions && this.customOptions.showMainBranch) {
            this.showMainBranch = this.customOptions.showMainBranch;
            const mainBranch = Utils.evaluate(this.customOptions.showMainBranch.condition, { value: this.branches });
            if (mainBranch) {
                this.showMainBranch.hasMainBransh = true;
                this.showMainBranch.fields.forEach(item => {
                    if (item.type == "pair") {
                        const key = this.translateService.currentLang.toLowerCase() == 'ar' ? item.nameAr : item.nameEn;
                        item.value = mainBranch[key].split(' - ')[0];
                    }
                    else item.value = mainBranch[item.name];
                });
            }
        }
    }

    private afterChangeValue() {
        if (this.customOptions && this.customOptions.afterChange)
            this.customOptions.afterChange.forEach(item => {
                if (item.value) {
                    const value = Utils.evaluate(item.value, { branches: _cloneDeep(this.branches), data: this.data, instance: this.formioComponent });
                    this.data[item.key] = value;
                }

                if (item.justInData) {
                    const value = Utils.evaluate(item.value, { branches: _cloneDeep(this.branches), data: this.data, instance: this.formioComponent });
                    this.data[item.key] = value;
                } else
                    if (this.formioComponent.root.wizard) {
                        const pages = this.formioComponent.root.getFastPages({ all: true, withoutFirstLoad: true });
                        const components = Utils.searchComponents(pages, { key: item.key });
                        components.forEach(c => {
                            if (item.notifyChange) {
                                c.calculateValue(this.data);
                                c.triggerChange();
                            }
                            else {
                                const value = Utils.evaluate(item.value, { branches: _cloneDeep(this.branches), data: this.data, instance: this.formioComponent });
                                c.setValue(value);
                            }
                        });
                    } else {
                        const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form', 'component.display': 'wizard' });
                        nestedForms.forEach(formComponent => {
                            formComponent.subFormReady.then((subForm) => {
                                const pages = subForm.getFastPages({ all: true, withoutFirstLoad: true });
                                const components = Utils.searchComponents(pages, { key: item.key });
                                components.forEach(c => {
                                    if (item.notifyChange) {
                                        c.calculateValue(this.data);
                                        c.triggerChange();
                                    }
                                    else {
                                        const value = Utils.evaluate(item.value, { branches: _cloneDeep(this.branches), data: this.data, instance: this.formioComponent });
                                        c.setValue(value);
                                    }
                                });
                            });
                        });
                    }
            });
    }

    private getFiledsValue(node, justIds: boolean = false) {
        let item = {};
        if (!justIds) {
            for (const [key, value] of Object.entries(node.rowSubmission.data)) {
                item[key] = value;
            }
            item[`_id`] = node.rowSubmission._id;
        }
        item[`${node.apiKey}SubmissionId`] = node.rowSubmission._id;
        return item;
    }

    private getChildrensValue(item, node, justIds: boolean = false) {
        if (justIds) {
            const subProps = node.actions.filter(q => q.bindWith).map(q => q.bindWith);
            subProps.forEach(key => {
                const apiKey = this.findNode(this.customOptions, key)[key].apiKey;
                item[apiKey] = [];
            });

            if (node?.childrens?.length > 0) {
                node.childrens.forEach(q => {
                    const child = this.getFiledsValue(q, justIds);
                    if (q.childrens.length > 0) this.getChildrensValue(child, q, justIds);
                    if (item && item[q.apiKey]) item[q.apiKey].push(child);
                });
            }
        } else {
            const subProps = node.actions.filter(q => q.bindWith).map(q => q.bindWith);
            subProps.forEach(key => {
                item[key] = [];
            });

            if (node?.childrens?.length > 0) {
                node.childrens.forEach(q => {
                    const child = this.getFiledsValue(q, justIds);
                    if (q.childrens.length > 0) this.getChildrensValue(child, q, justIds);
                    if (item && item[q.translatedName]) item[q.translatedName].push(child);
                });
            }
        }
    }

    private fillData() {
        const levelsIds: Array<{ node: any, ids: string[] }> = [];
        this.value.branchesData.forEach(item => {
            const key = Object.keys(item).find(q => q.endsWith('SubmissionId'))
            const node = this.findNodeByKey(this.customOptions, key.replace('SubmissionId', ''));
            this.recursiveFillResourceLevel(levelsIds, item, key, node);
        });

        if (this.customOptions.saveResultObjectsOn && this.data[this.customOptions.saveResultObjectsOn] && this.data[this.customOptions.saveResultObjectsOn].length) {
            this.fillDataResult(levelsIds, this.data[this.customOptions.tableTreeLevels]);
        } else {
            if (levelsIds && levelsIds.length) this.formioLoader.loading = true;
            const apiRequests = levelsIds.map(q => {
                return this.resourceNameService.loadCustomByFilterdKey(q.node.resource, `_id__in=${q.ids.join()}&sort=created`);
            });
            forkJoin(apiRequests).subscribe(result => {
                this.fillDataResult(levelsIds, result);
            }, error => {
                this.formioLoader.loading = false;
            });
        }
    }

    private fillDataResult(levelsIds: any[], result: any[]) {
        this.branches = [];
        this.dataSource.next([]);
        this.filterDataSource.next([]);

        result[0].forEach(q => {
            const item = this.fillFromApi(levelsIds, 0, q, result);
            this.branches.push(item);
        });

        this.branches.forEach(data => {
            const level = this.customOptions;
            const item = {
                fields: _cloneDeep(level[Object.keys(level)[0]].fields),
                icon: level[Object.keys(level)[0]].icon,
                color: level[Object.keys(level)[0]].color,
                apiKey: level[Object.keys(level)[0]].apiKey,
                parentApiKey: level[Object.keys(level)[0]].parentApiKey,
                extra: level[Object.keys(level)[0]].extra,
                disableFields: level[Object.keys(level)[0]].disableFields,
                resource: level[Object.keys(level)[0]].resource,
                rowSubmission: result[0].find(q => q._id == data._id),
                parentRowSubmission: null,
                childrens: []
            };
            item.fields.forEach(prop => {
                if (data[prop.name]) prop.value = data[prop.name];
            });
            const currentNode = this.fillSource(item, level, null, false);
            level[Object.keys(level)[0]].actions.filter(q => q.bindWith).forEach(element => {
                if (data[element.bindWith]) {
                    const node = this.findNode(this.customOptions, element.bindWith);
                    this.findAndFillSubData(data[element.bindWith], node, currentNode, result, levelsIds, null, false);
                }
            });
        });

        this.filterData();
        this.formioLoader.loading = false;
        this.notifyValue();

        if (this.customOptions.showMainBranch &&
            this.customOptions.showMainBranch.enableDefaultSelect &&
            this.filteredTreeSource.data.length &&
            !this.modifyInDialog) {
            this.viewDialog(this.filteredTreeSource.data[0]);
        }
    }

    private recursiveFillResourceLevel(levelsIds, item, key, node) {

        const index = levelsIds.findIndex(q => q.node.resource == node.resource);
        if (index >= 0) {
            levelsIds[index].ids.push(item[key]);
        }
        else levelsIds.push({ node: node, ids: [item[key]] });

        const bindWith = node.actions.find(q => !!q.bindWith)?.bindWith ?? null;

        if (bindWith)
            node.childrens.filter(q => q[bindWith]).forEach(element => {
                (item[element[bindWith].apiKey] ?? []).forEach(item => {
                    const key = Object.keys(item).find(q => q.endsWith('SubmissionId'))
                    const node = this.findNodeByKey(this.customOptions, key.replace('SubmissionId', ''));
                    this.recursiveFillResourceLevel(levelsIds, item, key, node);
                });
            });

    }

    private fillFromApi(levelsIds, levelsIdsIndex, nodeApiData, allApisData) {
        const item = { ...nodeApiData.data, _id: nodeApiData._id };

        const subProps = levelsIds[levelsIdsIndex].node.actions.filter(q => q.bindWith).map(q => q.bindWith);
        subProps.forEach(key => {
            const subNode = this.findNode(this.customOptions, key)[key];
            const subNodeIndex = levelsIds.findIndex(q => q.node.resource == subNode.resource);
            if (subNodeIndex >= 0) {
                const tempItems = allApisData[subNodeIndex].filter(q => q.data[levelsIds[subNodeIndex].node.parentApiKey] == item._id);
                tempItems.forEach(tempItem => {
                    const temp = this.fillFromApi(levelsIds, subNodeIndex, tempItem, allApisData);
                    if (!item[key]) item[key] = [];
                    item[key].push(temp);
                });
            }
        });
        return item;
    }

    private findAndFillSubData(array, level, parrentNode, result, levelsIds, parentRowSubmission = null, notify: boolean) {
        array.forEach(data => {
            const item = {
                fields: _cloneDeep(level[Object.keys(level)[0]].fields),
                icon: level[Object.keys(level)[0]].icon,
                color: level[Object.keys(level)[0]].color,
                apiKey: level[Object.keys(level)[0]].apiKey,
                parentApiKey: level[Object.keys(level)[0]].parentApiKey,
                extra: level[Object.keys(level)[0]].extra,
                disableFields: level[Object.keys(level)[0]].disableFields,
                resource: level[Object.keys(level)[0]].resource,
                rowSubmission: result[levelsIds.findIndex(q => q.node.resource == level[Object.keys(level)[0]].resource)].find(q => q._id == data._id),
                parentRowSubmission: parentRowSubmission,
                childrens: []
            };
            item.fields.forEach(prop => {
                if (data[prop.name]) prop.value = data[prop.name];
            });
            const currentNode = this.fillSource(item, level, parrentNode, notify);
            level[Object.keys(level)[0]].actions.filter(q => q.bindWith).forEach(element => {
                if (data[element.bindWith]) {
                    const node = this.findNode(this.customOptions, element.bindWith);
                    this.findAndFillSubData(data[element.bindWith], node, currentNode, result, levelsIds, item.rowSubmission, notify);
                }
            });
        });
    }

    /* Selection Code */
    checklistSelection = new SelectionModel<any>(true);
    getLevel = (node: any) => node.level;

    todoLeafItemSelectionToggle(node: any): void {
        this.checklistSelection.toggle(node);
        this.checkAllParentsSelection(node);
    }

    checkAllParentsSelection(node: any): void {
        let parent: any | null = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    }

    getParentNode(node: any): any | null {
        const currentLevel = this.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        if (!this.treeControl.dataNodes) return;
        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];

            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    checkRootNodeSelection(node: any): void {
        const nodeSelected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected = descendants.length > 0 && descendants.every(child => {
            return this.checklistSelection.isSelected(child);
        });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    }

    descendantsAllSelected(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected = descendants.length > 0 && descendants.every(child => {
            return this.checklistSelection.isSelected(child);
        });
        // if (descAllSelected) this.checklistSelection.select(node);
        // else this.checklistSelection.deselect(node);
        return descAllSelected;
    }

    descendantsPartiallySelected(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some(child => this.checklistSelection.isSelected(child));
        return result && !this.descendantsAllSelected(node);
    }

    todoItemSelectionToggle(node: any): void {
        this.checklistSelection.toggle(node);
        const descendants = this.treeControl.getDescendants(node);
        this.checklistSelection.isSelected(node)
            ? this.checklistSelection.select(...descendants)
            : this.checklistSelection.deselect(...descendants);

        // Force update for the parent
        descendants.forEach(child => this.checklistSelection.isSelected(child));
        this.checkAllParentsSelection(node);
    }

    /* End Selection Code */

    ngOnDestroy() {
        if (this.sub) this.sub.unsubscribe();
    }
}
